import { isBeyondMaxBookingDate } from './timeUtils';

export const validateStep1 = (formData, externalOrderIdConfig = {}) => {
  const errors = {};

  if (!formData.fromLanguageId) {
    errors.fromLanguageId = 'translation_order_from_language_required';
  }

  if (!formData.desiredDeliveryDate) {
    errors.desiredDeliveryDate = 'translation_order_delivery_date_required';
  } else if (isBeyondMaxBookingDate(formData.desiredDeliveryDate)) {
    // TUL-5698: a separator-less `250926` is parsed as the year 250926
    errors.desiredDeliveryDate = 'translation_order_delivery_date_too_far';
  }

  if (!formData.toLanguageId) {
    errors.toLanguageId = 'translation_order_to_language_required';
  }

  if (formData.fromLanguageId && formData.toLanguageId && formData.fromLanguageId === formData.toLanguageId) {
    errors.toLanguageId = 'translation_order_languages_must_differ';
  }

  // Only validated when the backend provided translator levels (the question
  // is hidden otherwise). The chips block deselecting the last one, so this
  // only triggers if the selection was never initialized.
  if (
    formData.translationLevels?.length > 0 &&
    (!formData.translatorLevelIds || formData.translatorLevelIds.length === 0)
  ) {
    errors.translatorLevelIds = 'translation_order_translator_type_required';
  }

  if (!formData.attachments || formData.attachments.length === 0) {
    errors.attachments = 'translation_order_files_required';
  } else {
    const attachmentErrors = [];
    formData.attachments.forEach((att, index) => {
      const attError = {};
      const scopeNum = Number(att.estimatedScope);
      if (!att.estimatedScope || isNaN(scopeNum) || scopeNum <= 0) {
        attError.estimatedScope = 'translation_order_scope_required';
      }
      if (!att.scopeType) {
        attError.scopeType = 'translation_order_scope_type_required';
      }
      if (Object.keys(attError).length > 0) {
        attachmentErrors[index] = attError;
      }
    });
    if (attachmentErrors.some(att => att)) {
      errors.attachmentErrors = attachmentErrors;
    }
  }

  // External order id mandatory check (org-level toggle from user.userGroup)
  const { externalOrderIdUsed, externalOrderIdMandatory } = externalOrderIdConfig;
  if (externalOrderIdUsed && externalOrderIdMandatory && !formData.externalOrderId?.trim()) {
    errors.externalOrderId = 'required';
  }

  return errors;
};

export const validateStep2 = () => {
  // No required fields in step 2 currently
  return {};
};
